/**
 * ── Susurro brand font — SINGLE SOURCE OF TRUTH ───────────────────────────────
 *
 * This is the ONE place where the app declares "my default typeface is X". The
 * brand font is bundled and self-contained (see `src/styles/brand-font.css` +
 * the `--font-brand*` tokens in `src/styles/global.css`); it is ALWAYS present
 * and never depends on the font catalog/CDN/network. It is also the target of the
 * "Reset to default" control.
 *
 * Nunito — a rounded humanist sans whose soft terminals carry the warmth and
 * closeness of an intimate whisper, matching Susurro's plum/periwinkle/teal
 * identity while staying crisp and legible in chat.
 *
 * The catalog fonts are a purely ADDITIVE layer on top: a user MAY switch to one,
 * but that is never required for the app to have its typeface.
 *
 * TO ADAPT PER APP (propagation): change `family` to this app's brand family and
 * keep it in sync with the bundled @font-face + `--font-brand*` CSS tokens.
 */
export const BRAND_FONT = {
  /**
   * CSS family name of the bundled brand typeface. MUST match the `@font-face`
   * `font-family` in `styles/brand-font.css` and the `--font-brand*` tokens.
   */
  family: "Nunito",
  /** Human-readable label shown next to the "Reset to default" control. */
  label: "Nunito",
} as const;
